const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`256fbe29e482db368885ce09e275e471f038e285dbe375ee8eb4566b93aba11e`, `256fbe29e482db368885ce09e275e471f038e285dbe375ee8eb4566b93aba11e`, 1, 126), undefined, true, false, 1));
            }

            getTemplateName() {
                return `256fbe29e482db368885ce09e275e471f038e285dbe375ee8eb4566b93aba11e`;
            }

            getSourceContext() {
                return new this.Source(``, `256fbe29e482db368885ce09e275e471f038e285dbe375ee8eb4566b93aba11e`, ``);
            }
        }],
        [126, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/cloud-cover/cloud-cover.twig`, `256fbe29e482db368885ce09e275e471f038e285dbe375ee8eb4566b93aba11e`, 1);

                this.blocks = new Map([
                    ['heading', [this, 'block_heading']],
                    ['content', [this, 'block_content']],
                    ['scene', [this, 'block_scene']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/cloud-cover/cloud-cover.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_heading(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/heading/heading.twig`, new Map([[`level`,  -2], [`content`, `What We Do`]]), false, false, 3));
                this.echo(`  `);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    <p>
      We
      `);
                this.echo(this.include(context, this.source, `@cloudfour/components/icon/icon.twig`, new Map([[`name`, `heart`], [`title`, `love`], [`inline`, true]]), false, false, 11));
                this.echo(`      <span class="u-hidden-visually">love</span>
      solving tough puzzles through design and&nbsp;code.
    </p>
  `);
            }

            block_scene(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    <img class="c-cloud-cover__scene-object" src="`);
                this.echo(this.env.getFilter('escape').traceableCallable(21, this.source)(...[this.env, (context.has(`image`) ? context.get(`image`) : null), `html`, null, true]));
                this.echo(`" alt="Example">
  `);
            }

            getTemplateName() {
                return `256fbe29e482db368885ce09e275e471f038e285dbe375ee8eb4566b93aba11e`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `256fbe29e482db368885ce09e275e471f038e285dbe375ee8eb4566b93aba11e`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '256fbe29e482db368885ce09e275e471f038e285dbe375ee8eb4566b93aba11e');

let template = env.loadTemplate('256fbe29e482db368885ce09e275e471f038e285dbe375ee8eb4566b93aba11e');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/cloud-cover/demo/scene.twig", args: context }
     );
     return rendered;;
};